import Swiper from 'swiper';
import { breakpoints } from '../conf';

export default () => {
  const el = document.querySelector('[data-banner-swiper]');

  const options = {
    loop: true,
    autoHeight: true,
    updateOnImagesReady: true,
    preloadImages: true,
    watchOverflow: true,
    pagination: {
      el: '[data-banner-swiper-pagination]',
      clickable: true
    },
    navigation: {
      nextEl: '[data-banner-swiper-next]',
      prevEl: '[data-banner-swiper-prev]'
    }
  };


  if(el) {
    const slideCount = el.dataset.bannerSwiperSlides;

    if (slideCount && parseInt(slideCount) && parseInt(slideCount) < 2) {
      options.loop = false;
    }
  
    var mySwiper = new Swiper('[data-banner-swiper]', options);
  }
};